import { backendApi } from "./axios";
import { SUBSCRIPTION_ENDPOINTS } from "./endpoints";

const subscribe = (payload) => {
  return backendApi.post(SUBSCRIPTION_ENDPOINTS.SUBSCRIBE, payload);
};

const getMy = () => {
  return backendApi.get(SUBSCRIPTION_ENDPOINTS.MY);
};

const changePackage = (payload) => {
  return backendApi.post(SUBSCRIPTION_ENDPOINTS.CHANGE_PACKAGE, payload);
};

const changePreview = (packageId) => {
  return backendApi.get(SUBSCRIPTION_ENDPOINTS.CHANGE_PREVIEW, { params: { packageId } });
};

const cancel = (payload) => {
  return backendApi.post(SUBSCRIPTION_ENDPOINTS.CANCEL, payload);
};

const cancelPending = () => {
  return backendApi.delete(SUBSCRIPTION_ENDPOINTS.CANCEL_PENDING);
};

export default { subscribe, getMy, changePackage, changePreview, cancel, cancelPending };
